module.exports = __webpack_public_path__ + "media/GGDB_DREAMWALL_LOOP.83d92157.mp4";